import { apiClient } from '_app'
import { ApiResponse } from 'dtos'
import { NeedsToHaveBoxFinishedDto, NeedsToHaveBoxFinishedQueryParams } from 'dtos/toDoLists/ohioBuildABoxes'
import { URIQuery } from 'utils'

const baseUrl = (): string => `/api/to-do-lists/ohio-build-a-boxes/needs-to-have-box-finished`

export const getNeedsToHaveBoxFinishedToDoList = (queryParams: NeedsToHaveBoxFinishedQueryParams) =>
  apiClient.get<ApiResponse<NeedsToHaveBoxFinishedDto[]>>(baseUrl() + URIQuery(queryParams)).then(res => res.data)
